﻿import * as HttpDataServiceBase from '../core/httpdataservicebase';
import * as Model from  '../models/models';
import * as LogService  from '../core/services/logservice/log.service';
import * as MessageBarService from '../core/services/messageBarService/messageBar.service';
import IAppSettings from '../../iApp.settings';


export class BillingStatementRepository extends HttpDataServiceBase.DataServiceBase<Model.IBillingStatement> {

    static $inject = ['$q', '$http', 'logService', 'appSettings', 'messageBarService'];

    constructor($q: ng.IQService, $http: ng.IHttpService, logger: LogService.ILogService, appSettings: IAppSettings, messageBarService: MessageBarService.MessageBarService)
    {
        super($q, $http, logger, messageBarService, appSettings.apiPath + '/billingstatements/policyholder');
        this.appSettings = appSettings;
    }

    private appSettings: IAppSettings;

    public getBillingStatementByPolicyHolderId(policyHolderId: string, suppressErrorPageOnError?: boolean): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/billingstatements/policyholder/${policyHolderId}`;

        return this.$http.get(url)
        .then((response: ng.IHttpPromiseCallbackArg<Model.IBillingStatement>) => this.successHandler(response))
        .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
    }

    public billingStatementLogSearchAsync(searchCriteria: Model.IBillingStatementLogSearchCriteria): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/billingstatementlogs/search`;

        return this.$http.post(url, searchCriteria)
            .then((response: ng.IHttpPromiseCallbackArg<Array<Model.IBillingStatement>>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
    }

    public billingStatementLogPaymentResponseSearchAsync(searchCriteria: Model.IBillingStatementLogPaymentResponseSearchCriteria): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/billingstatementlogpaymentresponse/search`;

        return this.$http.post(url, searchCriteria)
            .then((response: ng.IHttpPromiseCallbackArg<Array<Model.IBillingStatementLogPaymentResponse>>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
    }


    protected transformInboundModel(model: Model.IBillingStatement): Model.IBillingStatement {
        super.transformInboundModel(model);

        const currentMailDate = model.currentMailDate as any as string;
        if (currentMailDate != null) {
            model.currentMailDate = new Date(currentMailDate);
        }

        const currentDueDate = model.currentDueDate as any as string;
        if (currentDueDate != null) {
            model.currentDueDate = new Date(currentDueDate);
        }

        const nextDueDate = model.nextDueDate as any as string;
        if (nextDueDate != null) {
            model.nextDueDate = new Date(nextDueDate);
        }
        return model;
    }
}